import domReady from '@wordpress/dom-ready';

function getEmbedUrl(url) {
  if (!url) {
    return '';
  }

  const youtubeMatch = url.match(
    /(?:youtube\.com\/watch\?v=|youtube\.com\/embed\/|youtu\.be\/)([\w-]+)/
  );
  if (youtubeMatch) {
    return `https://www.youtube.com/embed/${youtubeMatch[1]}?autoplay=1`;
  }

  const vimeoMatch = url.match(/vimeo\.com\/(?:.*\/)?(\d+)/);
  if (vimeoMatch) {
    return `https://player.vimeo.com/video/${vimeoMatch[1]}?autoplay=1`;
  }

  // Fallback: assume the URL is already embeddable (oEmbed-friendly link).
  return url;
}

function closeModal(modal) {
  modal.classList.remove('open');
  document.documentElement.classList.remove('scroll-disabled');

  const videoWrapper = modal.querySelector('.pn-youtube');
  if (videoWrapper) {
    videoWrapper.innerHTML = '';
  }
}

domReady(() => {
  document.querySelectorAll('[data-component="modal"]').forEach((wrapper) => {
    const modal = wrapper.querySelector('.modal');
    const videoWrapper = modal ? modal.querySelector('.pn-youtube') : null;
    const trigger = wrapper.querySelector('.btn-video');
    const closeBtn = modal ? modal.querySelector('.cross') : null;

    if (!modal || !videoWrapper || !trigger) {
      return;
    }

    trigger.addEventListener('click', (event) => {
      event.preventDefault();

      const embedUrl = getEmbedUrl(trigger.getAttribute('href'));

      if (!embedUrl) {
        return;
      }

      videoWrapper.innerHTML = `<iframe src="${embedUrl}" frameborder="0" allow="autoplay; encrypted-media; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
      modal.classList.add('open');
      document.documentElement.classList.add('scroll-disabled');
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', () => closeModal(modal));
    }

    // Close when clicking the backdrop (outside the video itself).
    modal.addEventListener('click', (event) => {
      if (event.target === modal) {
        closeModal(modal);
        document.documentElement.classList.remove('scroll-disabled');
      }
    });
  });
});
